export class EmailAlreadyInUseException extends Error {
  constructor() {
    super('The provided email is already in use by an existing user. Each user must have a unique email.');
  }
}
